import Seo from "../../../Shared/SEO";
import CampaignLayout from "../../../Layout/CampaignLayout";
import { PageProps } from "./types";
import Banner from "./banner";

import Intro from "./intro";
import Video from "./video";
import Features from "./features";
import Connect from "./connect";
import Models from "./model";
import Future from "./future";
import Faq from "./faq";
import styles from "./styles.module.scss";

import { data as features } from './features/data';
import Bikes from "./model/bikes";

const Disclaimer = () => {
	return (
		<div className={styles.disclaimer}>
			<p className={styles.paragraph}>View the <a href="/legal/privacy-policy">privacy policy</a> or <a href="/legal/website-terms-and-conditions">terms of use.</a></p>
		</div>
	);
}

const Content = (props: PageProps) => {
	return (
		<div className={styles.contentContainer}>
			<Banner />
			<Intro
				title="Focus On Your Ride While Staying Connected"
				description="Honda RoadSync is intuitive to use, featuring voice recognition input, voice feedback, and a 4-way toggle switch located on the left handlebar. With your phone safely in your pocket, you can stay connected and focus on the road, making every ride enjoyable and hassle-free."
			/>
			<Video
				id="lIwZq_zDYyM"
				label="Honda RoadSync in Action"
			/>
			<Features
				logo="/roadsync/features/dark-logo.png"
				data={features}
				background="/roadsync/features/bg.jpg"
			/>
			<Connect />
			<div className={styles.padBottom}>
				<Models
					buttons={[
						{
							size: "large",
							type: "button",
							colour: "red",
							buttonLink: {
								type: "Url",
								url: "/motorcycles/hornet",
								text: "Honda Hornet",
							},
						},
						{
							size: "large",
							type: "button",
							colour: "red",
							buttonLink: {
								type: "Url",
								url: "/motorcycles/transalp",
								text: "Honda Transalp",
							},
						},
					]}
					MovableLayer={Bikes}
					title="Available for Hornet and Transalp"
					description="<p>Currently only available for the Honda Hornet and Honda Transalp in South Africa. Other models coming soon.</p>"
					background="/roadsync/bg-models.jpg"
				/>
			</div>
			<Future />
			<Faq />
			<Disclaimer />
		</div>
	);
};

const RoadsyncCampaignPageInner = ({ data }: PageProps) => {
	return (
		<div style={{ backgroundColor: data.page.pageColour ? data.page.pageColour : '#FFF' }}>
			<Seo seo={data.seo} />
			<CampaignLayout
				type={data.type}
				nav={data.page.nav.header.links}
				logo={data.page.nav.header.logos[data.page.logo]}
				root="cm"
				footer={data.page.nav.footer}
			>
				<Content data={data} />
			</CampaignLayout>
		</div >
	);
};

export default RoadsyncCampaignPageInner;